module.exports = __webpack_public_path__ + "static/media/australia.665d4d9c.png";